<template>
  <el-container>
    <el-header>
      <img src="../assets/img/logo.png" width="60px" height="60px" alt="检测鉴定人员技术培训在线学习系统" style="cursor: pointer;"
           @click="()=>{this.$router.push('/home')}">
      <span style="color: white; margin-left:10px;font-size: 24px;font-weight: bold;">检测鉴定人员技术培训在线学习系统</span>
    </el-header>
    <el-main>
      <!--登录-->
      <transition-group name="slide">
        <div class="common-form" v-show="MODAL_STATUS === STATUS_LOGIN" :key="STATUS_LOGIN">
          <el-row type="flex" justify="space-between" style="margin-bottom: 10px;text-align: right">
            <el-col :span="4">
              <div class="form-title">登录</div>
            </el-col>
            <!--<el-col :span="8">-->
            <!--  <el-link type="primary" @click="changeLoginWay(LOGIN_FORM)" v-if="loginForm.isPasswordLogin">手机验证码登录-->
            <!--  </el-link>-->
            <!--  <el-link type="primary" @click="changeLoginWay(LOGIN_FORM)" v-else>密码登录</el-link>-->
            <!--</el-col>-->
          </el-row>
          <el-row>
            <el-form :ref="LOGIN_FORM" :model="loginForm" :rules="loginFormRules" :validate-on-rule-change="false">
              <!--<el-form-item prop="mobile">-->
              <!--  <el-input prefix-icon="el-icon-mobile-phone" v-model="loginForm.mobile" placeholder="手机号" clearable></el-input>-->
              <!--</el-form-item>-->
              <!--<el-form-item prop="password" v-if="loginForm.isPasswordLogin">-->
              <!--  <el-input prefix-icon="el-icon-lock" v-model="loginForm.password"-->
              <!--            placeholder="密码" show-password autocomplete="new-password" @keyup.enter.native="login(LOGIN_FORM)"></el-input>-->
              <!--</el-form-item>-->
              <!----- 修改 ------>
              <el-form-item prop="idnum">
                <el-input prefix-icon="el-icon-s-custom" v-model="loginForm.idnum" placeholder="身份证号码"
                          clearable></el-input>
              </el-form-item>
              <el-form-item prop="examno">
                <el-input prefix-icon="el-icon-c-scale-to-original" v-model="loginForm.examno" placeholder="准考证号"
                          clearable></el-input>
              </el-form-item>
              <!----- 修改 ------>
              <el-form-item prop="verificationCode" v-if="!loginForm.isPasswordLogin">
                <el-input prefix-icon="el-icon-message" v-model="loginForm.verificationCode"
                          placeholder="手机验证码" autocomplete="new-password"
                          @keyup.enter.native="login(LOGIN_FORM)"></el-input>
                <span class="sms-btn">
                    <el-button type="primary" size="mini" @click="sendSms(LOGIN_FORM,'L')"
                               :disabled="!loginForm.isAllowSendSms">
                        {{ loginForm.isAllowSendSms ? '获取验证码' : '重新发送(' + loginForm.timeCount + 's)' }}
                    </el-button>
                </span>
              </el-form-item>
              <el-form-item prop="imageCode">
                <el-input prefix-icon="el-icon-picture-outline" v-model="loginForm.imageCode" placeholder="图形验证码"
                          @keyup.enter.native="login(LOGIN_FORM)"></el-input>
                <span class="img-code"><img alt="图形验证码" @click="loadImageCode()" :src="imageCodeVal"
                                            style="cursor: pointer;"/></span>
              </el-form-item>
              <el-row v-show="loginForm.isPasswordLogin" style="margin-bottom: 10px">
                <el-col :span="3">
                  <el-checkbox v-model="isRememberPwd">记住密码</el-checkbox>
                </el-col>
                <el-col :span="6" :offset="15">
                  <!--<el-link type="primary" @click="changeForm(LOGIN_FORM, STATUS_FORGET)">忘记密码</el-link>-->
                </el-col>
              </el-row>
              <el-form-item>
                <el-button :loading="loading" type="primary" @click="login(LOGIN_FORM)" style="width: 100%">
                  <span v-if="!loading">登 录</span>
                  <span v-else>登 录 中...</span>
                </el-button>
              </el-form-item>
            </el-form>
          </el-row>
          <!--<el-row type="flex" justify="center">-->
          <!--  <el-col :span="5">-->
          <!--    <el-link type="primary" @click="changeForm(LOGIN_FORM, STATUS_REGISTER)">我要注册</el-link>-->
          <!--  </el-col>-->
          <!--</el-row>-->
        </div>

        <!--注册-->
        <div class="common-form" v-show="MODAL_STATUS === STATUS_REGISTER" :key="STATUS_REGISTER">
          <el-row type="flex" justify="center" style="margin-bottom: 10px">
            <el-col :span="4">
              <div class="form-title">注册</div>
            </el-col>
          </el-row>
          <el-row>
            <el-form :ref="REGISTER_FORM" :model="registerForm" :rules="registerFormRules"
                     :validate-on-rule-change="false">
              <el-form-item prop="mobile">
                <el-input prefix-icon="el-icon-mobile-phone" v-model="registerForm.mobile" placeholder="手机号"
                          clearable></el-input>
              </el-form-item>
              <el-form-item prop="verificationCode">
                <el-input prefix-icon="el-icon-message" v-model="registerForm.verificationCode"
                          placeholder="手机验证码"></el-input>
                <span class="sms-btn">
                  <el-button type="primary" size="mini" @click="sendSms(REGISTER_FORM,'R')"
                             :disabled="!registerForm.isAllowSendSms">
                    {{ registerForm.isAllowSendSms ? '获取验证码' : '重新发送(' + registerForm.timeCount + 's)' }}
                  </el-button>
                </span>
              </el-form-item>
              <el-form-item prop="name">
                <el-input prefix-icon="el-icon-user" v-model="registerForm.name" placeholder="姓名" clearable></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input prefix-icon="el-icon-lock" v-model="registerForm.password" placeholder="密码" show-password
                          autocomplete="new-password"></el-input>
              </el-form-item>
              <el-form-item prop="confirmPwd">
                <el-input prefix-icon="el-icon-lock" v-model="registerForm.confirmPwd" placeholder="确认密码" show-password
                          autocomplete="new-password"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="register(REGISTER_FORM)" style="width: 100%">
                  <span v-if="!loading">注 册</span>
                  <span v-else>注 册 中...</span>
                </el-button>
              </el-form-item>
            </el-form>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="5">
              <el-link type="primary" @click="changeForm(REGISTER_FORM, STATUS_LOGIN)">我要登录</el-link>
            </el-col>
          </el-row>
        </div>

        <!--忘记密码-->
        <div class="common-form" v-show="MODAL_STATUS === STATUS_FORGET" :key="STATUS_FORGET">
          <el-row type="flex" justify="center" style="margin-bottom: 10px">
            <el-col :span="8">
              <div class="form-title">忘记密码</div>
            </el-col>
          </el-row>
          <el-row>
            <el-form :ref="FORGET_FORM" :model="forgetForm" :rules="forgetFormRules" :validate-on-rule-change="false">
              <el-form-item prop="mobile">
                <el-input prefix-icon="el-icon-mobile-phone" v-model="forgetForm.mobile" placeholder="手机号"
                          clearable></el-input>
              </el-form-item>
              <el-form-item prop="verificationCode">
                <el-input prefix-icon="el-icon-message" v-model="forgetForm.verificationCode"
                          placeholder="手机验证码"></el-input>
                <span class="sms-btn">
                    <el-button type="primary" size="mini" @click="sendSms(FORGET_FORM,'F')"
                               :disabled="!forgetForm.isAllowSendSms">
                        {{ forgetForm.isAllowSendSms ? '获取验证码' : '重新发送(' + forgetForm.timeCount + 's)' }}
                    </el-button>
                </span>
              </el-form-item>
              <el-form-item prop="password">
                <el-input prefix-icon="el-icon-lock" v-model="forgetForm.password" placeholder="新密码" show-password
                          autocomplete="new-password"></el-input>
              </el-form-item>
              <el-form-item prop="confirmPwd">
                <el-input prefix-icon="el-icon-lock" v-model="forgetForm.confirmPwd" placeholder="确认新密码" show-password
                          autocomplete="new-password"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetPassword(FORGET_FORM)" style="width: 100%">重置</el-button>
              </el-form-item>
            </el-form>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="5">
              <el-link type="primary" @click="changeForm(FORGET_FORM, STATUS_LOGIN)">我要登录</el-link>
            </el-col>
          </el-row>
        </div>
      </transition-group>
    </el-main>

    <edu-foot></edu-foot>
  </el-container>
</template>

<script>
const EduHead = () => import('../components/EduHead');
const EduFoot = () => import('../components/EduFoot');
export default {
  name: "Login",
  components: {
    EduHead,
    EduFoot
  },
  data() {
    return {
      // 表单标记
      STATUS_LOGIN: 'STATUS_LOGIN',
      STATUS_REGISTER: 'STATUS_REGISTER',
      STATUS_FORGET: 'STATUS_FORGET',
      MODAL_STATUS: '',

      // 表单名称
      LOGIN_FORM: 'loginForm',
      REGISTER_FORM: 'registerForm',
      FORGET_FORM: 'forgetForm',

      // 登录表单数据
      loginForm: {
        mobile: '',
        imageCode: '',
        password: '',
        verificationCode: '',
        isAllowSendSms: true,
        timeCount: 60,
        timer: '',
        idnum: '',
        examno: '',
        isPasswordLogin: true,
      },
      // 登录表单验证规则
      loginFormRules: {
        idnum: [{validator: this.ElementValidator.validateIdNum, trigger: 'blur'}],
        examno: [{validator: this.ElementValidator.validateExamNo, trigger: 'blur' }],
        mobile: [{validator: this.ElementValidator.validateMobile, trigger: 'blur'}],
        imageCode: [{validator: this.ElementValidator.validateImageCode, trigger: 'blur'}],
        password: [{validator: this.validatePwdOrCode, trigger: 'blur'}],
        verificationCode: [{validator: this.validatePwdOrCode, trigger: 'blur'}]
      },

      // 注册表单数据
      registerForm: {
        mobile: '',
        verificationCode: '',
        name: '', //姓名
        password: '',
        confirmPwd: '',
        isAllowSendSms: true,
        timeCount: 60,
        timer: '',
      },
      // 注册表单验证规则
      registerFormRules: {
        mobile: [{validator: this.ElementValidator.validateMobile, trigger: 'blur'}],
        verificationCode: [{validator: this.ElementValidator.validateMobileCode, trigger: 'blur'}],
        name: [{validator: this.ElementValidator.validateName, trigger: 'blur'}],
        password: [{validator: this.ElementValidator.validatePasswordWeak, trigger: 'blur'}],
        confirmPwd: [{validator: this.validateConfirmPwd, trigger: 'blur'}],
      },

      // 忘记密码表单数据
      forgetForm: {
        mobile: '',
        verificationCode: '',
        password: '',
        confirmPwd: '',
        isAllowSendSms: true,
        timeCount: 60,
        timer: '',
      },
      // 忘记密码表单验证规则
      forgetFormRules: {
        mobile: [{validator: this.ElementValidator.validateMobile, trigger: 'blur'}],
        verificationCode: [{validator: this.ElementValidator.validateMobileCode, trigger: 'blur'}],
        password: [{validator: this.ElementValidator.validatePasswordWeak, trigger: 'blur'}],
        confirmPwd: [{validator: this.validateConfirmPwd, trigger: 'blur'}]
      },

      loading: false,
      isRememberPwd: false,
      imageCodeToken: '',
      imageCodeVal: '',
      redirectUrl: ''
    }
  },
  methods: {
    mousedown(e) {
      e.preventDefault()
    },
    login(formName) {
      /*防止用户重复登录*/
      this.$store.commit('refreshUser');
      if (this.$store.state.userInfo) {
        this.$router.push({path: this.redirectUrl ? this.redirectUrl : '/home'});
        return;
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const originPassword = this[formName].password;
          this[formName].imageCodeToken = this.imageCodeToken;
          this[formName].loginName = this[formName].mobile;
          this[formName].password = hex_md5(this[formName].password + KEY);

          // const {success, content, message} = await this.$http.post('/system/web/user/login', this[formName]);
          const {success, content, message} = await this.$http.post('/system/web/user/login', this[formName]);
          if (success) {
            if (this.isRememberPwd) {
              const userData = {
                mobile: this[formName].mobile,
                password: originPassword,
                idnum: this[formName].idnum,   // 新加
                examno: this[formName].examno,  // 新加
              };
              LocalStorage.set(LOCAL_KEY_REMEMBER_MEMBER, userData);
            } else {
              LocalStorage.remove(LOCAL_KEY_REMEMBER_MEMBER);
            }
            content.examno = this[formName].examno   //  存储用户的准考证号
            content.idnum = this[formName].idnum   //  存储用户的身份证
            this.$store.commit('login', {userInfo: content, redirectUrl: this.redirectUrl});

            await this.$router.push('/home/mine/course/All')
            // 判断是否需要实名认真
            // this.$http.get("/business/web/certification/getByUserId").then((res) => {
            //   if (!res.content || !res.content.isVerify) {
            //     this.$confirm("<spqn>你尚未进行实名认证，是否前往？</spqn>", "", {
            //       confirmButtonText: '前往认证',
            //       cancelButtonText: '暂不认证',
            //       dangerouslyUseHTMLString: true,
            //       customClass: 'cer-info',
            //       center: true,
            //     }).then(() => {
            //       this.$router.push('/home/mine/certification')
            //     })
            //   }
            // })
          } else {
            this.loadImageCode();
            this[formName].password = '';
            this[formName].verificationCode = '';
            this[formName].imageCode = '';
          }
          this.loading = false;
        }
      });
    },
    register(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this[formName].loginName = this[formName].mobile;
          this[formName].password = hex_md5(this[formName].password + KEY);

          const {success} = await this.$http.post('/system/web/user/register', this[formName]);
          if (success) {
            this.$message.success("注册成功");
            this.changeForm(formName, this.STATUS_LOGIN);
            this.loginForm.mobile = this[formName].loginName
          } else {
            this.$message.error("注册失败!");
            this[formName].password = '';
            this[formName].confirmPwd = '';
          }
          this.loading = false;
        }
      });
    },
    resetPassword(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this[formName].loginName = this[formName].mobile;
          this[formName].password = hex_md5(this[formName].password + KEY);

          const {success} = await this.$http.post('/system/web/user/updatePassword', this[formName]);
          if (success) {
            this.$message.success("修改密码成功");
            this.changeForm(formName, this.STATUS_LOGIN);
          } else {
            this.$message.error("修改密码失败");
          }
        }
      });
    },
    changeLoginWay(formName) {
      this.$refs[formName].resetFields();
      this.loginForm.isPasswordLogin = !this.loginForm.isPasswordLogin;
    },
    changeForm(formName, status) {
      if (this.STATUS_LOGIN === status) {
        this.loadImageCode();
      }
      this.$refs[formName].resetFields();
      this.MODAL_STATUS = status;
    },
    /**
     *  加载图形验证码
     */
    loadImageCode() {
      this.imageCodeToken = Tool.uuid(8);
      this.imageCodeVal = process.env.VUE_APP_SERVER + '/business/web/kaptcha/image-code/' + this.imageCodeToken;
    },
    /**
     * 发送手机验证码
     */
    async sendSms(formName, useType) {
      let mobile = this[formName].mobile;

      if (!this.ElementValidator.validateMobile(null, mobile, null)) {
        this.$message.error('请输入正确手机号 !');
        return;
      }

      // 暂时不调接口
      this.setTime(formName);
      const param = {
        mobile: mobile,
        useType: useType
      }
      await this.$http.post("/business/web/sms/send", param);
      /*const { data: data } = await this.$ajax.get(process.env.VUE_APP_SERVER + '/business/web/member/is-mobile-exist/' + mobile);
      if (data.success) {
          Toast.warning("手机号已被注册");
      } else {
          // 调服务端发送短信接口
          const sms = {
              mobile: mobile,
              use: SMS_USE.LOGIN.key
          };
          const { data: smsData } = await this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/sms/send', sms);
          console.log(smsData);
          if (smsData.success) {
              Toast.success("短信已发送");
              // 开始倒计时
              this.setTime(formName);
          } else {
              Toast.warning(smsData.message);
          }
      }*/
    },
    /**
     * 发送短信倒计时
     */
    setTime(formName) {
      const form = this[formName];
      form.isAllowSendSms = false;
      form.timer = setInterval(() => {
        form.timeCount--;
        if (form.timeCount < 0) {
          form.isAllowSendSms = true;
          form.timeCount = 60;
          clearInterval(form.timer);
        }
      }, 1000);
    },
    /**
     * 登录时密码和短信验证二选一
     */
    validatePwdOrCode(rule, value, callback) {
      if (this.loginForm.isPasswordLogin) {
        this.ElementValidator.validatePasswordWeak(rule, value, callback);
      } else {
        this.ElementValidator.validateMobileCode(rule, value, callback);
      }
      callback();
    },
    validateConfirmPwd(rule, value, callback) {
      if (!value) callback(new Error('确认密码不能为空'));
      if (this.MODAL_STATUS === this.STATUS_REGISTER) {
        if (value === this.registerForm.password) return callback();
      } else if (this.MODAL_STATUS === this.STATUS_FORGET) {
        if (value === this.forgetForm.password) return callback();
      }
      callback(new Error('确认密码和密码不一致'));
    }
  },
  mounted() {
    this.MODAL_STATUS = this.STATUS_LOGIN;
    this.loadImageCode();

    const userData = LocalStorage.get(LOCAL_KEY_REMEMBER_MEMBER);
    if (userData) {
      this.isRememberPwd = true;
      this.loginForm.mobile = userData.mobile;
      this.loginForm.password = userData.password;
      // 新加
      this.loginForm.idnum = userData.idnum;
      this.loginForm.examno = userData.examno;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name) {
        vm.redirectUrl = from.path;
      }
      vm.$store.commit('refreshUser');
      const userInfo = vm.$store.state.userInfo;
      if (userInfo) {
        vm.redirectUrl ? next(vm.redirectUrl) : next('/home');
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('refreshUser')
    next();
  },

}
</script>


<style lang="scss" scoped>
.el-header {
  display: flex;
  height: 92px !important;
  align-items: center;
  padding-left: 65px;
  box-shadow: 0 4px 10px 0 rgba(153, 153, 159, 0.2);
  z-index: 999;
  background: url("../assets/img/head-bg.jpg") no-repeat;
  background-size: cover;
}

.el-container {
  position: relative;
  min-height: 100%;
  overflow-y: hidden;
}

.el-main {
  min-height: 600px;
  position: relative;
  padding: 0;
  background-color: #f8f9fa;
  overflow-y: hidden;
}

.form-title {
  font-size: 20px;
  margin-bottom: 3px;
}

.common-form {
  position: absolute;
  width: 320px;
  padding: 20px 50px;
  left: 0;
  right: 0;
  margin: 2% auto;
  background-color: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.img-code {
  position: absolute;
  right: 10px;
  height: 100%;
  line-height: 62px;
  z-index: 10;
}

.sms-btn {
  position: absolute;
  right: 10px;
  height: 100%;
  z-index: 10;
}

.slide-enter-active {
  transition: all 0.3s linear;
}

.slide-enter {
  transform: translateX(-100px);
  opacity: 0;
}
</style>
<style lang="scss">
.cer-info {
  width: 500px;

  .el-message-box__message p {
    font-size: 20px;
    padding: 10px 10px;
  }

  .el-button--default {
    width: 100px;
    height: 40px;
    font-size: 16px;
  }

  .el-button--primary {

  }
}
</style>
